require.context("../images", true);
import "src/decidim/extra_user_fields/signup_form";
import "src/decidim/extra_user_fields/benchmarking_multiselect";
